// eslint-disable-next-line import/prefer-default-export
export const RoutePath = {
  GET_STARTED_PATH: '/',
  OAUTH_CALLBACK_PATH: '/oauth/callback',
  LOGOUT_PATH: '/logout',
  FAILED_CAPTURES: '/failed-captures',
};
